import * as React from 'react';
import { BaseSelect } from '../../../shared/components/inputs';

export const ColumnMenu = ({ mappings, setMapping, mappingsSet, ...props }) => {
  const handleMappingSelected = (value) => {
    setMapping({ id: value?.id, column: props.column.field, displayName: value?.displayName });
  };

  const value = mappingsSet.find((m) => m.column === props.column.field);

  return (
    <BaseSelect
      data={mappings}
      dataItemKey='id'
      textField='displayName'
      value={value}
      onChange={(e) => handleMappingSelected(e.value)}
    />
  );
};
